/* eslint-disable no-param-reassign */
// Store all required selectors
const buttonSelectors: Array<string> = [
  '.button',
  '.blogCard__readmore',
  '.maatregel__link',
  'input[type="submit"]',
  '.wp-block-button__link',
  '.blogCard__tag',
  '.pill',
  '.partnerFilter__term',
  '.button--outline',
  'a[data-partner="true"]',
  '.cookieNotice__btn',
];

// Create temporary array to allow depth
const buttonElementsBuild: Array<HTMLElement | Array<HTMLElement>> = [];

// For all selectors, add them to the build array
buttonSelectors.forEach((selector) => {
  // Search for items
  const foundItems = Array.from(<NodeListOf<HTMLElement>>document.querySelectorAll(selector));
  // Push to array
  buttonElementsBuild.push(foundItems);
});

// @ts-ignore Flatten the build array for usage
const buttonElements: Array<HTMLElement> = buttonElementsBuild.flat(Infinity);

// Initalize the tracking
function initTracking() {
  this.tracker.classList.add('active');
}

// Track mouse cursor to animate object
function startTracking(event: MouseEvent) {
  // Calculate absolute position
  const cumulativeOffset = (element) => {
    let top = 0;
    let left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return {
      top,
      left,
    };
  };

  // Get button position
  const buttonPos = cumulativeOffset(this.button);

  // Calculate mouse pos relative to element
  const mousePos = {
    x: event.pageX - buttonPos.left - 48,
    y: event.pageY - buttonPos.top - 48,
  };

  // Move tracker to mouse position
  this.tracker.style.transform = `translate(${mousePos.x}px, ${mousePos.y}px)`;
}

// Remove tracked element
function stopTracking() {
  this.tracker.classList.remove('active');
  this.tracker.style.transition = '';
  this.tracker.style.opacity = '';
}

// Fade out tracker on mouse down
function faderTracking() {
  this.tracker.style.transition = 'opacity .2s ease-out, transform .2s ease-out';
  this.tracker.style.transform += 'scale(5)';
  this.tracker.style.opacity += '0';
}

// Check if there are buttons on page
if (buttonElements) {
  // Add event listeners to all buttons
  buttonElements.forEach((button) => {
    // Create tracker element
    const tracker = document.createElement('span');
    tracker.classList.add('buttonTracker');

    // Add tracker to the button
    button.append(tracker);

    // Prepare data for binding
    const data = {
      tracker,
      button,
    };

    // Add event listeners to the button
    button.addEventListener('mouseenter', initTracking.bind(data), false);
    button.addEventListener('mousemove', startTracking.bind(data), false);
    button.addEventListener('mouseleave', stopTracking.bind(data), false);
    button.addEventListener('mousedown', faderTracking.bind(data), false);
  });
}
